import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PreviousProductAdCard = ({ ad }) => {
    // console.log(ad)
    const navigate = useNavigate()
    const [focusedImg, setFocusedImg] = useState(ad?.product.files[0]?.url)
    if (!ad) return null;



    // Formatting helpers
    const formatCurrency = (val) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val);
    const formatDate = (date) => new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

    const imageFiles = ad?.product.files?.filter(f => f.type === "image") || [];
    const renderImages = () => (
        <>
            <div className="focused-image">
                <img src={focusedImg} alt="onnize" />
            </div>

            {imageFiles.length > 0 && (
                <div className="image-selector">
                    {imageFiles.map((file, i) => (
                        <div
                            key={i}
                            className="image-selector-wrapper"
                            onClick={() => setFocusedImg(file?.url)}
                        >
                            <img src={file?.url} alt={file.name} />
                        </div>
                    ))}
                </div>
            )}
        </>
    );

    const renderVideo = (file) => (
        <div className="video-container">
            <video controls>
                <source src={file?.url} type={file.mimeType} />
            </video>
        </div>
    );

    const renderFiles = () => {
        if (!ad.product.files?.length) return null;

        switch (ad.product.files[0].type) {
            case "image":
                return renderImages();
            case "video":
                return renderVideo(ad?.files[0]);
            default:
                return null;
        }
    };
    return (
        <article className="ad-card">
            <header className="ad-card-header">
                <span className="ad-type-tag">Product</span>
                <div className="ad-status">
                    <span
                        className="ad-status-dot"
                        style={{ backgroundColor: ad.active.isActive ? '#22c55e' : '#ef4444' }}
                    ></span>
                    {ad.active.isActive ? 'Live' : 'Inactive'}
                </div>
            </header>

            <small className="ad-id-label">ID: {ad._id}</small>

            <section className="ad-metrics-grid">
                <div className="ad-text">
                    <p>{ad.postText}</p>
                </div>
                <div className="">
                    {renderFiles()}
                </div>
                <div className="metric-item">
                    <span className="metric-label">Total Budget</span>
                    <span className="metric-value">{formatCurrency(ad.budget)}</span>
                </div>
                <div className="metric-item">
                    <span className="metric-label">Profile Visits</span>
                    <span className="metric-value">{ad.results.visits}</span>
                </div>
            </section>

            <div className="ad-details-list">
                <div className="detail-row">
                    <span className="detail-label">Started:</span>
                    <span className="detail-value">{formatDate(ad.startDate)}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Ends:</span>
                    <span className="detail-value">{formatDate(ad.endDate)}</span>
                </div>
                <div className="detail-row">
                    <span className="detail-label">Payment:</span>
                    <span className="detail-value" style={{ color: ad.payments.status === 'pending' ? '#f59e0b' : '#10b981' }}>
                        {ad.payments.status.toUpperCase()}
                    </span>
                </div>
            </div>

            <footer className="ad-card-footer">
                <button className="btn-view-analytics">
                    Analyze Performance
                </button>
            </footer>
            <button className="promote-again-btn" onClick={() => navigate(`/${ad.organization.name}/admin/promotions/posts/create`, { state: { ad:ad.product, adType: "product" } })}>
                Promote Again
            </button>
        </article>
    );
};

export default PreviousProductAdCard